import React, { useState } from "react";
import type { ServiceFaqItem } from "../../api/services";

interface ServiceFaqProps {
  items: ServiceFaqItem[];
}

const ServiceFaq: React.FC<ServiceFaqProps> = ({ items }) => {
  const [active, setActive] = useState<number>(items[0]?.id ?? 1);

  const toggleAccordion = (index: number) => {
    setActive(active === index ? -1 : index);
  };

  return (
    <div className="service-process-wrap pt-120 pb-125">
      <div className="row mt-none-50 align-items-center">
        {/* LEFT SIDE ACCORDION */}
        <div className="col-lg-6 mt-50">
          <h2 className="details-content-title mb-40">How ordering works</h2>

          <div className="service_process_faq">
            <div className="accordion">
              {items.map((item) => (
                <div className="accordion-item" key={item.id}>
                  <div
                    className={`accordion-button ${
                      active === item.id ? "" : "collapsed"
                    }`}
                    role="button"
                    onClick={() => toggleAccordion(item.id)}
                  >
                    {item.title}
                  </div>

                  <div
                    className={`accordion-collapse collapse ${
                      active === item.id ? "show" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <p className="m-0">{item.content}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* RIGHT SIDE CLICKABLE LIST */}
        <div className="col-lg-6 mt-50">
          <ul className="content_layer_group list-unstyled">
            {items.map((item) => (
              <li
                key={item.id}
                onClick={() => toggleAccordion(item.id)}
                className={active === item.id ? "active" : ""}
              >
                <span>{item.title.replace(/^\d+\.\s/, "")}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ServiceFaq;
